module.exports = __webpack_public_path__ + "img/2016.170d746a.png";